import { TagDefinition } from 'types/TagRefDefinition';

export function flattenTags(items: Array<TagDefinition>): Array<TagDefinition> {
  const flattened: Array<any> = [];

  items.forEach((item) => {
    flattened.push({ ...item, childTags: [] });
    if (item.childTags?.length > 0) {
      flattened.push(...flattenTags(item.childTags));
    }
  });

  return flattened;
}
